import { render, staticRenderFns } from "./add-shipments.vue?vue&type=template&id=9f1a811c&scoped=true"
import script from "./add-shipments.vue?vue&type=script&lang=js"
export * from "./add-shipments.vue?vue&type=script&lang=js"
import style0 from "./add-shipments.vue?vue&type=style&index=0&id=9f1a811c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1a811c",
  null
  
)

export default component.exports